module.exports = "https://cdn.littlereply.com/tt/resource/sp_place_x@3x.5bf1e1709472e6bc5c4182d2af1310bf.png";